import React, { useState, useEffect } from 'react';
import styles from './styles/paginated-options.module.css';
import { addAnswer } from '@/store/slices/chatbotFlow';
import { connect } from 'react-redux';
import { Button, Space } from 'antd';
import { LeftOutlined, RightOutlined, DownOutlined } from '@ant-design/icons';

export const maxOptions = 5;

const PaginatedOptions = (props) => {
  const [options, setOptions] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);

  const totalPages = Math.ceil((props?.block?.options?.answers?.length || 0) / maxOptions);

  useEffect(() => {
    paginate(0);
  }, []);

  const showMoreOptions = () => {
    setOptions(props?.block?.options?.answers);
    setShowMore(true);
  };

  const showLessOptions = () => {
    setOptions(props?.block?.options?.answers.slice(0, maxOptions));
    setShowMore(false);
  };

  const paginate = (pageNumber) => {
    let newOptions = props?.block?.options?.answers;
    if (totalPages === pageNumber + 1) {
      newOptions = newOptions.slice(pageNumber * maxOptions, newOptions.length);
    } else {
      newOptions = newOptions.slice(pageNumber * maxOptions, (pageNumber + 1) * maxOptions);
    }
    setOptions(newOptions);
    setPageNumber(pageNumber);
  };

  return (
    <>
      <div className={styles.wrapper}>
        {options.map(option => (
          <div
            key={option.id}
            className={styles.option}
            onClick={() => props.addAnswer(option.title)}
          >
            {option.title}
          </div>
        ))}
        {props?.block?.options?.answers?.length > maxOptions && props?.block?.options?.showMore && !showMore &&
          <p className={styles.option} onClick={showMoreOptions}>
            Show More <DownOutlined style={{ fontSize: '10px' }} />
          </p>
        }
      </div>
      {props?.block?.options?.answers?.length > maxOptions && !props?.block?.options?.showMore &&
        <div className={styles.pagination_wrapper}>
          <Space size="small" align="center" direction="horizontal">
            <Button type={'text'} size={'large'}
                disabled={pageNumber === 0}
                onClick={() => paginate(pageNumber - 1)}
                icon={<LeftOutlined style={{ fontSize: 14 }} />}
            />
            <Button  type={'text'} size={'large'}
                disabled={pageNumber + 1 === totalPages}
                onClick={() => paginate(pageNumber + 1)}
                icon={<RightOutlined style={{ fontSize: 14 }} />}
            />
          </Space>
        </div>}
    </>
  );
};

const mapDispatchToProps = {
  addAnswer,
};

export default connect(null, mapDispatchToProps)(PaginatedOptions);
